import { history } from "../../src/index";

import * as types from '../constants/documentdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as documentdetailsApi from '../api/documentdetails';

export function resetDocument() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DOCUMENT_RESET });
    }
}

export function setDocumentDetails(data) {
    // console.log("getDocumentDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DOCUMENT_REQUEST_COMPLETED, data: data });
    }
}

export function getDocumentDetails( id) {
    // console.log("getDocumentDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DOCUMENT_REQUEST });
        documentdetailsApi.getDocument(id)
            .then(function (response) {
                // console.log("getDocumentDetails action", response)
                dispatch({ type: types.FETCH_DOCUMENT_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getDocumentDetails Error", err)
                dispatch({ type: types.FETCH_DOCUMENT_REQUEST_ERROR });
            });
    }
}

export function getDocumentDetailsList(committee_id) {
    // console.log("getDocumentDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DOCUMENT_LIST_REQUEST });
        documentdetailsApi.getDocumentList(committee_id)
            .then(function (response) {
                // console.log("getDocumentDetailsList", response)
                dispatch({ type: types.FETCH_DOCUMENT_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getDocumentDetailsList Error", err)
                dispatch({ type: types.FETCH_DOCUMENT_LIST_REQUEST_ERROR });
            });
    }
}

export function addDocumentDetails(committee_id, objModel) {
    // console.log("addDocumentDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DOCUMENT_REQUEST });
        documentdetailsApi.addDocument(committee_id, objModel)
            .then(function (response) {
                // console.log("addDocumentDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DOCUMENT_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/document/document-list/'+committee_id);
                }
                dispatch({ type: types.ADD_DOCUMENT_RESET });
            })
            .catch(function (err) {
                // console.log("addDocumentDetails action err", err)
                dispatch({ type: types.ADD_DOCUMENT_REQUEST_ERROR });
            });
    }
}

export function updateDocumentDetails(committee_id, objModel) {
    // console.log("updateDocument action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DOCUMENT_REQUEST });
        documentdetailsApi.updateDocument(committee_id, objModel)
            .then(function (response) {
                // console.log("updateDocument action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DOCUMENT_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/document/document-list/'+committee_id);
                }
            })
            .catch(function (err) {
                // console.log("updateDocument action err", err)
                dispatch({ type: types.ADD_DOCUMENT_REQUEST_ERROR });
            });
    }
}

export function updateFileDetails(id, objModel) {
    // console.log("updateFileDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.UPDATE_FILE_REQUEST });
        documentdetailsApi.updateFile(id, objModel)
            .then(function (response) {
                // console.log("updateFileDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.UPDATE_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    // history.push('/document/add-document/' + id);
                }
            })
            .catch(function (err) {
                // console.log("updateFileDetails action err", err)
                dispatch({ type: types.UPDATE_FILE_REQUEST_ERROR });
            });
    }
}

export function deleteDocumentDetails(id,committee_id) {
    // console.log("updateDocument action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DOCUMENT_REQUEST });
        documentdetailsApi.deleteDocument(id)
            .then(function (response) {
                // console.log("updateDocument action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DOCUMENT_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/document/document-list/'+committee_id);
                }
            })
            .catch(function (err) {
                // console.log("updateDocument action err", err)
                dispatch({ type: types.ADD_DOCUMENT_REQUEST_ERROR });
            });
    }
}

export function deleteDocumentFileDetails(id,documentid) {
    // console.log("updateDocument action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DOCUMENT_REQUEST });
        documentdetailsApi.deleteDocumentFile(id)
            .then(function (response) {
                // console.log("updateDocument action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DOCUMENT_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    // history.push('/document/add-document/'+documentid);
                }
            })
            .catch(function (err) {
                // console.log("updateDocument action err", err)
                dispatch({ type: types.ADD_DOCUMENT_REQUEST_ERROR });
            });
    }
}



// WEBPACK FOOTER //
// ./actions/documentdetails.js